import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { CustomerFormType, CustomerType, CvsFormatType } from './types'

export class CustomersService {
  static getCustomers(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<CustomerType[]>> {
    return apiService.get('/customers', config)
  }

  static getCustomerById(id: string): Promise<AxiosResponse<CustomerFormType>> {
    return apiService.get(`/customers/${id}`)
  }

  static generateCSVCustomer(): Promise<AxiosResponse<CvsFormatType>> {
    return apiService.post('customers/generate-csv')
  }
}
